
// @ts-nocheck





import { i18nText } from '@/locales';


import { Component, Prop, Vue } from 'vue-property-decorator';
import VisitGeneralForm from "@/form/visits/visitGeneral";
import {ITableColumn} from "@/entity/table/table.types";
import { ClientsStore } from '@/store/modules/Clients';
import { IClientsListItem } from '@/entity/clients/clients.types';
import { PaginationMix } from '@/UI/mixins/PaginationMix';
import { LoyaltyCertFormData } from '@/form/loyalty/loyaltyCert/LoyaltyCert';
import { LoyaltyCertMix } from "@/UI/mixins/Loaylty/LoyaltyCertMix";
import { mixins } from 'vue-class-component';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
//import { ProxyDataForm } from '@/UI/components/Helpers/ProxyDataForm';
import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
import { Table } from 'ant-design-vue';
import { loyaltySubscriptionForm } from '@/form/loyalty/loyaltySubscription/loyaltySubscription';
import { LoyaltySubscriptionStore } from '@/store/modules/Loyalty/Subscription/LoyaltySubscription';
import { LoyaltySubscriptionTypeStore } from '@/store/modules/Loyalty/Subscription/LoyaltySubscriptionType';
import { LoyaltyCertStore } from '@/store/modules/Loyalty/Cert/LoyaltyCert';
import { LoyaltyCertTypeStore } from '@/store/modules/Loyalty/Cert/LoyaltyCertType';
import { ILoyaltyCertListItem } from '@/entity/loyalty/loyaltyCert/loyaltyCert/loyaltyCert.types';
import { ILoyaltyCertTypeListItem } from '@/entity/loyalty/loyaltyCert/loyaltyCertType/LoyaltyCertType.types';
import { ServiceStore } from '@/store/modules/Services';
import { ServiceFormData } from '@/form/serviceCreate/Service';
import { IServicesListItem } from '@/entity/services/services.types';
import { ServicesCategoryStore } from '@/store/modules/ServicesCategory';
import { ServiceCosmetologistsStore } from '@/store/modules/ServiceCosmetologists';
import { ProductsStockStore } from '@/store/modules/Warehouse/ProductsStock';
import { DataEntity, Products } from '@/entity/warehouse/Products/Products.types';
import { VisitsGeneralMix } from "@/UI/mixins/Visits/VisitsGeneralMix";
import { VisitsStore } from "@/store/modules/Visits";
import { CashBoxMix } from "@/UI/mixins/CashBoxMix";
import { CashboxStore } from '@/store/modules/Finance/Cashbox';
import { VisitPayFormData, formRules } from "@/form/visits/Pay/Visit";

@Component({
    components: {
        'a-table': Table,
        BaseDataForm,
    }
})

export default class VisitStatus extends mixins (SimpleProxyForm, LoyaltyCertMix, PaginationMix, VisitsGeneralMix, CashBoxMix) {
    @Prop() form!:  VisitGeneralForm;
    @Prop() visit_id!: number;

    get columns(): ITableColumn[] {
        return [
            {
                title: i18nText("Позиция"),
                dataIndex: '',
                key: 'name',
                width: '40%',
                scopedSlots: {
                    customRender: 'name',
                }
            },
            {
                title: i18nText("Кол-во"),
                dataIndex: 'created',
                key: 'created',
                scopedSlots: {
                    customRender: 'created',
                }
            },
            {
                title: i18nText("Цена, ₽"),
                dataIndex: 'balance',
                key: 'balance',
                scopedSlots: {
                    customRender: 'balance',
                }
            },
            {
                title: i18nText("Скидка, %"),
                dataIndex: 'discount',
                key: 'discount',
                scopedSlots: {
                    customRender: 'discount',
                }
            },
            {
                title: i18nText("Итог, ₽"),
                dataIndex: 'total',
                key: 'total',
                scopedSlots: {
                    customRender: 'total',
                }
            },
            {
                title: '',
                dataIndex: 'delete',
                key: 'delete',
                scopedSlots: {
                    customRender: 'delete',
                }
            },
        ]
    }

    autoExpandParent = true
    modalWindowServices = false
    modalWindowProducts = false
    showPayModal = false;
    confirmLoading = false;

    formCerificate = new LoyaltyCertFormData();
    formSubsscription = new loyaltySubscriptionForm()
    service = new ServiceFormData()
    visitPayForm = new VisitPayFormData();
    
    modalWindowCertificate = false
    modalWindowsSubscription = false

    visibleCashCashboxes = false;
    visibleCardCashboxes = false;

    treeProducts: Array <any> = []
    treeServices: Array <any> = []
    expandedRowKeys: Array <any> = []

    expandedKeysServices: any = []
    checkedKeysServices: any = []
    selectedKeysServices = []
    expandedKeysProduct: any = []
    checkedKeysProduct: any = []
    selectedKeysProduct = []

    dataClients: Array <IClientsListItem> = []
    dataloyaltyCertsTypes: Array <ILoyaltyCertTypeListItem> = []
    dataService: Array <IServicesListItem> = []
    dataProducts: Array <DataEntity> = []
    productsList: Array <Record<any, any>> = []

    boxDataCertificate: any[] = []
    boxDataSubscription: any[] = []
    boxData: any[] = []
    dataSubscriptionTypes: any = []
    total_price: number = 0;
    saveBasketKey = 1;

    addCode() {
        this.formCerificate = new LoyaltyCertFormData();
    }

    get products()
    {
        return ProductsStockStore.items;
    }

    get services()
    {
        return ServiceStore.service;
    }

    get subscriptionsTypes()
    {
        return LoyaltySubscriptionTypeStore.loyaltySubscriptionTypes;
    }

    get certificates()
    {
        return LoyaltyCertStore.loyaltyCerts;
    }

    get certificateTypes()
    {
        return LoyaltyCertTypeStore.loyaltyCertTypes;
    }

    get cash_cashboxes(): any {
        if(this.cashBoxes && this.cashBoxes.data)
        {
            return this.cashBoxes.data.filter(e => e && e.type && e.type.id == 1);
        } else {
            return [];
        }
    }

    get card_cashboxes(): any {
        if(this.cashBoxes && this.cashBoxes.data)
        {
            return this.cashBoxes.data.filter(e => e && e.type && e.type.id == 2);
        } else {
            return [];
        }
    }

    handlePayCancel(): void {
        this.showPayModal = false;
    }

    async handlePayOk(): Promise<void> {
        this.showPayModal = false;
        this.visitPayForm.visit_id = this.form.id;
        try {

            let result = await this.saveBasket();

            if(result) {
                const hide = this.$message.loading({content: i18nText("Загрузка"), key: 'proceed_pay'});
                let response = await VisitsStore.pay(this.visitPayForm);
                //hide();
                if(response && response.status)
                {
                    this.$message.success({content: response.response, key: 'proceed_pay'});
                } else if(response && response.response) {
                    this.$message.error({content: response.response, key: 'proceed_pay'});
                }
                await VisitsStore.fetchData({ filter: { id: this.visit_id } });
            }

        } catch (e: any) {
            console.log(i18nText("Ошибка платежа"));
            this.$message.error({content: i18nText("Произошла неизвестная ошибка"), key: 'proceed_pay'});
        }
    }
    setStatus(key:any){
        if(!this.disabled) {
            this.form.status_id = Number(key);
            this.status = Number(key);
            this.$emit('status-change', Number(key));
        }
    }

    async created(): Promise<void> {

        await this.fetchClients('')
        await this.fetchCertificatesTypes()
        await this.fetchSubscriptionsTypes()
        await this.fetchService()
        await this.fetchProducts()

        if(!this.visit_id)
        {
            this.visit_id = this.form.id;
        }

        try {
            await CashboxStore.fetchAll({ filter: { salon_id: this.form.salon_id } });
            await VisitsStore.fetchData({ filter: { id: this.visit_id } });
            await this.setBasket();

            this.tableLoad = true;
            this.formReady = true;
        } catch (e) {
            console.log("error parse Visit Data");
        }
    }

    async setBasket(): Promise<void> {
        if(this.visit && this.visit.basket)
        {

            this.form.client_id = this.visit.client.id;

            for(let i = 0; i < this.visit.basket.services.length; i++)
            {
                await this.addTableSelectService(this.visit.basket.services[i].service_id, this.visit.basket.services[i]);
            }

            for(let i = 0; i < this.visit.basket.products.length; i++)
            {
                await this.addTableSelectProducts(this.visit.basket.products[i].product_id, this.visit.basket.products[i]);
            }

            for(let i = 0; i < this.visit.basket.memberships.length; i++)
            {
                let data: Record<any, any> = {
                    type: 'membership',
                    key:    this.visit.basket.memberships[i].membership_id,
                    name:  i18nText("Абонемент №") + this.visit.basket.memberships[i].membership.membership_number,
                    created: this.visit.basket.memberships[i].quantity,
                    balance: this.visit.basket.memberships[i].price,
                    discount: this.visit.basket.memberships[i].discount,
                    total: 0
                }

                /*if(item.children && item.children.length)
                {
                    data.children = item.children
                }*/

                this.pushToBox(data)
            }

            for(let i = 0; i < this.visit.basket.certificates.length; i++)
            {
                let data: Record<any, any> = {
                    type: 'certificate',
                    key:    this.visit.basket.certificates[i].certificate_id,
                    name:   i18nText("Сертификат №") + this.visit.basket.certificates[i].certificate.code,
                    created: this.visit.basket.certificates[i].quantity,
                    balance: this.visit.basket.certificates[i].price,
                    discount: this.visit.basket.certificates[i].discount,
                    total: 0
                }

                this.pushToBox(data)
            }
        }
    }

    prepareBasket(): void {

        this.form.service_data = [];

        for(let i = 0; i < this.boxData.length; i++){
        
            let data: Record<any, any> = {
                'quantity': this.boxData[i].created,
                'price': this.boxData[i].balance,
                'discount': this.boxData[i].discount,
            };

            if(this.boxData[i].type == 'service') {
                data['service_id'] = this.boxData[i].key;
            } else if(this.boxData[i].type == 'product') {
                data['product_id'] = this.boxData[i].key;
            } else if(this.boxData[i].type == 'certificate') {

                if(this.boxData[i].key) {
                    data['certificate_id'] = this.boxData[i].key;
                }

                if(this.boxData[i].data) {
                    data['data'] = this.boxData[i].data;
                    data['type'] = 'certificate';
                    data['need_create'] = true;
                }

            } else if(this.boxData[i].type == 'membership') {

                if(this.boxData[i].key) {
                    data['membership_id'] = this.boxData[i].key;
                }

                if(this.boxData[i].data) {
                    data['data'] = this.boxData[i].data;
                    data['type'] = 'membership';
                    data['need_create'] = true;
                }

            } else {
                data = {};
            }

            if(data)
            {
                this.form.service_data.push(data)
            }
        }
    }

    async goToPayment(): Promise<void> {
        this.prepareBasket();
        const result: boolean = await this.saveBasket();

        if(result){
            this.$emit('changeCurrentPage', 2);
        }
    }

    async saveBasket(): Promise<boolean> {

        let result: boolean = false;

        try {
            const hide = this.$message.loading({content: i18nText("Загрузка"), key: this.saveBasketKey});

            const response: boolean = await this.form.submit(VisitsStore.update);
            
            hide();

            result = response;

            if(!response) {
                this.$message.error({content: i18nText("Произошла ошибка"), key: this.saveBasketKey});
            }

        } catch(e) {
            console.log(e);
            this.$message.error({content: i18nText("Произошла неизвестная ошибка"), key: this.saveBasketKey});
        }

        return result;
    }

    async proceedPay(id: number): Promise<void> {
        this.visibleCashCashboxes = false;
        this.visibleCardCashboxes = false;
        
        if(this.visit.order) {
            this.prepareBasket();
            this.visitPayForm.cashbox_id = id;
            this.visitPayForm.sum = this.visit.order.sum - this.visit.order.paid;
            this.showPayModal = true;
        } else {
            this.$message.error(i18nText("Не введена сумма оплаты"));
        }
    }

    async fetchCertificatesTypes(val?: string) {
        let data: Record<any, any> = { };

        if(val)
        {
            data.filter.name = val;
        }

        await LoyaltyCertTypeStore.fetchAll(data);
        if (LoyaltyCertTypeStore.loyaltyCertTypes?.data) {
            let items = []
            items = LoyaltyCertTypeStore.loyaltyCertTypes.data
            this.dataloyaltyCertsTypes = []
            items.forEach((item) => {
                this.dataloyaltyCertsTypes.push(item);
            })
        }
    }
    async fetchClients(value: string): Promise <void> {
        await ClientsStore.fetchAll({filter: {name: value, salon_id: this.$store.state.salon_id}});
        if (ClientsStore.clients?.data) {
            let items = []
            items = ClientsStore.clients.data
            this.dataClients = []
            items.forEach((item) => {
                this.dataClients.push(item);
            })
        }
    }
    async fetchSubscriptionsTypes(val?: string) {
        let data: Record<any, any> = { filter: {salon_id: this.$store.state.salon_id}};

        if(val)
        {
            data.filter.name = val;
        }
        await LoyaltySubscriptionTypeStore.fetchAll(data);
        if(this.subscriptionsTypes && this.subscriptionsTypes.data){
            this.dataSubscriptionTypes = []
            this.subscriptionsTypes.data.forEach((item) => {
                this.dataSubscriptionTypes.push(item);
            })
        }
    }
    async fetchProducts() {
        await ProductsStockStore.fetchAll({ filter: {salon_id: this.$store.state.salon_id}})
        if (this.products && this.products.data) {
            this.dataProducts = []
            const groups: Record<string, any> = {}

            let existItems: Array<number> = [];
            let existCategories: Array<number> = [];
            this.products.data.forEach((item) => {

                if(!existItems.includes(item.product_nomenclature_id))
                {
                    this.productsList.push({
                        title: item.nomenclature.name,
                        key: item.id
                    });
                    existItems.push(item.product_nomenclature_id);

                    if(!existCategories.includes(item.nomenclature.category_id)){
                        let array: Array<any> = [];
                        if(this.products && this.products.data)
                        {
                            let existKids: Array<number> = [];
                            for(let i = 0; i < this.products.data.length; i++)
                            {
                                if(!existKids.includes(this.products.data[i].nomenclature.id) && item.nomenclature.category.id == this.products.data[i].nomenclature.category_id)
                                {
                                    array.push({
                                        title: this.products.data[i].nomenclature.name,
                                        key: this.products.data[i].id,
                                    });
                                    existKids.push(this.products.data[i].nomenclature.id);
                                }
                            }
                        }

                        this.treeProducts.push({
                            title: item.nomenclature.category.name,
                            key: 'category_' + item.nomenclature.category.id,
                            children: array
                        })

                        existCategories.push(item.nomenclature.category_id);
                    }
                }
            })
        }
    }
    async fetchService() {
        await ServiceStore.fetchAll({limit: 0, filter: {salon_id: this.$store.state.salon_id}})
        if (this.services && this.services.data) {
            this.dataService = []
            const groups: Record<string, any> = {}
            const categories: Record<string, any> = {}

            this.services.data.forEach((item) => {
                if (groups[item.category.name]) {
                    groups[item.category.name].push(item)
                } else {
                    groups[item.category.name] = [item]
                }
                this.dataService.push(item);
            })
            for (const [key, elements] of Object.entries(groups)) {
                this.treeServices.push({
                    title: key,
                    key: key,
                    children: elements.map((element: any) => ({
                        title: element.name,
                        key: element.id
                    }))
                })
            }
        }
    }
    
    async addCertificatesInBox() {
        if(this.dataloyaltyCertsTypes)
        {
            let item = this.dataloyaltyCertsTypes.find(item => item.id === this.formCerificate.type_id);
            if(item)
            {
                let data: Record<any, any> = {
                    type: 'certificate',
                    name:   i18nText("Сертификат №") + this.formCerificate.code,
                    data: { type_id: this.formCerificate.type_id,  code: this.formCerificate.code},  
                    created: 1,
                    balance: item.balance,
                    discount: 0,
                    total: item.balance
                }

                this.pushToBox(data)
                this.formCerificate = new LoyaltyCertFormData()
                this.modalWindowCertificate = false
            }
        }
    }
    async addSubscriptionInBox() {
        if(this.dataSubscriptionTypes)
        {
            let item = this.dataSubscriptionTypes.find((record: any) => record.id === this.formSubsscription.membership_type_id);
            if(item)
            {
                let data: Record<any, any> = {
                    type: 'membership',
                    name:    item.name,  
                    data: { membership_type_id: this.formSubsscription.membership_type_id,  discount: this.formSubsscription.discount},  
                    created: 1,
                    balance: item.price,
                    discount: 0,
                    total: item.price
                }

                if(item.children && item.children.length)
                {
                    data.children = item.children
                }

                this.pushToBox(data)
                this.formSubsscription = new loyaltySubscriptionForm()
                this.modalWindowsSubscription = false
            }
        }
    }
    async addTableSelectService(serviceId: any, data?: Record<any, any>) {
        //await ServiceStore.fetchAll({limit: 10})
        if(this.services)
        { 
            let service = this.services.data.find(item => item.id === serviceId);
            if(service && !this.boxData.find(serv => serv.key === serviceId))
            {
                this.pushToBox({
                    type: 'service',
                    key: service.id,
                    name:    service.name,  
                    created: data && data.quantity ? data.quantity : 1,
                    balance: data && data.price ? data.price : service.price_first,
                    discount: data && data.discount ? data.discount : 0,
                    total: service.price_first
                })
            }
        }
    }
    async addTableSelectProducts(productId: any, data?: Record<any, any>) {
        if(this.products && this.products.data)
        {   
            let product = this.products.data.find(item => productId == item.id);
            if(product && !this.boxData.find(product => product.key === productId))
            {
                this.pushToBox({
                    type: 'product',
                    key: product.id,
                    name:    product.nomenclature.name,  
                    created: data && data.quantity ? data.quantity : 1,
                    balance: data && data.price ? data.price : parseInt(product.nomenclature.cost_price),
                    discount: data && data.discount ? data.discount : 0,
                    total: parseInt(product.nomenclature.cost_price)
                })
                console.log(product.id);
                if(this.form.products !== null)
                    this.form.products.push(product.id);
                console.log('products ->');
                console.log(this.form.products);
            }
        }
    }

    deleteData(id: number): void {
        const index = this.boxData.findIndex(t => t.key === id)
        this.boxData.splice(index, 1)
    }
    deleteDataInTable(record: any): void {
        const index = this.boxData.findIndex(item => item.name === record.name)
        this.boxData.splice(index, 1)
    }

    handleOkforServices() {
        const ids = this.checkedKeysServices.filter((s: any) => typeof s === 'number')
        for (const id of ids ) {
            const item = this.dataService.find(s => s.id === id)
            if(item && !this.boxData.find(service => service.key === id))
            {
                this.pushToBox({
                    type: 'service',
                    key:    item.id,
                    name:    item.name,  
                    created: 1,
                    balance: item.price_first,
                    discount: 0,
                    total: item.price_first
                })
            }
        }
        this.modalWindowServices = false
    }
    handleOkforProducts() {
        const ids = this.checkedKeysProduct.filter((s: any) => typeof s === 'number')
        if(this.products && this.products.data)
        {
            for (const id of ids ) {
                const item = this.products.data.find(s => s.id === id)
                if(item && !this.boxData.find(product => product.key === id))
                {
                    this.pushToBox({
                        type: 'product',
                        key:    item.id,
                        name:    item.nomenclature.name,  
                        created: 1,
                        balance: parseInt(item.nomenclature.cost_price),
                        discount: 0,
                        total: parseInt(item.nomenclature.cost_price)
                    })
                }
            }
        }
        this.modalWindowProducts = false
    }

    pushToBox(data: Record<any, any>)
    {
        this.boxData.push(data);
        this.calculator({});
    }

    onExpandServices(expandedKeysServices: string[]) {
        this.expandedKeysServices = expandedKeysServices;
        this.autoExpandParent = false;
    }
    onCheckServices(checkedKeysServices: string[]) {
        this.checkedKeysServices = checkedKeysServices;
    }
    onSelectServices(selectedKeysServices: never[]) {
        this.selectedKeysServices = selectedKeysServices;
    }
    onExpandProduct(expandedKeysProduct: string[]) {
        this.expandedKeysProduct = expandedKeysProduct;
        this.autoExpandParent = false;
    }
    onCheckProduct(checkedKeysProduct: string[]) {
        this.checkedKeysProduct = checkedKeysProduct;
    }
    onSelectProduct(selectedKeysProduct: never[]) {
        this.selectedKeysProduct = selectedKeysProduct;
    }

    calculator(record: Record<any, any>)
    {
        this.total_price = 0;
        for(let i = 0; i < this.boxData.length; i++)
        {
            if(this.boxData[i].key == record.key)
            {
                if(record.discount > 100)
                {
                    record.discount = 100;
                } 
                else if(record.discount < 0)
                {
                    record.discount = 0;
                } else if(isNaN(record.discount))
                {
                    record.discount = 0;
                }

                if(!record.discount)
                {
                    record.discount = this.boxData[i].discount;
                }
                if(!record.created)
                {
                    record.created = this.boxData[i].created;
                }
                if(!record.balance)
                {
                    record.balance = this.boxData[i].balance;
                }

                this.boxData[i].total = record.balance * record.created - (record.discount * record.balance / 100);
            }

            if(!record.key)
            {
                this.boxData[i].total = this.boxData[i].balance * this.boxData[i].created - (this.boxData[i].discount * this.boxData[i].balance / 100);
            }

            this.total_price += this.boxData[i].total;
        }

        let format = function(price:any, n:number, x:number, s:string, c:string){
             var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
                num = price.toFixed(Math.max(0, ~~n));

            return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
        }

        this.total_price = format(this.total_price, 2, 3, ' ', '.');
    }
}
